import ComponentCarouselItem from "./ComponentCarouselItem";

export default ComponentCarouselItem;
export { ComponentCarouselItem };
